import { ToastMessageType, ToastSeverityType } from 'primereact/toast';
import { IMyArgumentException } from '../interfaces';

export default class ErrorUtilities {

    static GetToastPropFromMyArgumentException(error: any) {
        let myArgumentException = error.response && error.response.data && this.InstanceOfMyArgumentException(error.response.data)
            ? error.response.data as IMyArgumentException : null;


        if (myArgumentException && myArgumentException.showMessageInClientApp) {
            let toastMessage: ToastMessageType = {
                severity: this.GetSeverityFromLogLevel(myArgumentException),
                summary: this.GetSummaryFromLogLevel(myArgumentException),
                detail: myArgumentException.message,
                life: 7000
            };
            return toastMessage;
        } else {
            return null;
        }
    };

    static GetMyArgumentExceptionFromError(error: any) {
        let myArgumentException = error.response && error.response.data && this.InstanceOfMyArgumentException(error.response.data)
            ? error.response.data as IMyArgumentException : null;

        return myArgumentException;
    };

    public static InstanceOfMyArgumentException(object: any): object is IMyArgumentException {
        return typeof object !== 'string' && 'showMessageInClientApp' in object && 'message' in object && 'logLevel' in object;
    };

    private static GetSeverityFromLogLevel(myArgumentException: IMyArgumentException): ToastSeverityType {
        switch (myArgumentException.logLevel) {
            case "Error":
            case "Info":
            case "Warn":
                return myArgumentException.logLevel.toLowerCase() as ToastSeverityType;
            default:
                return 'info'
        }
    };

    private static GetSummaryFromLogLevel(myArgumentException: IMyArgumentException): string {
        switch (myArgumentException.logLevel) {
            case "Info":
                return "Informazione";
            case "Error":
                return 'Errore';
            case "Warn":
            default:
                return "Attenzione";

        }
    };


}
